<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12">
        <AdministratorForm
          v-model="user"
          title="Nový administrátor"
          :loading="saving"
          @save="save"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapActions } from 'vuex'
import { SUCCESS_MESSAGES } from '@/enums/success-messages'
import AdministratorForm from '@/components/forms/AdministratorForm.vue'

export default {
  name: 'AdministratorAdd',
  components: {
    AdministratorForm,
  },
  data() {
    return {
      user: {},
      loading: false,
      saving: false,
    }
  },
  methods: {
    ...mapActions({
      createUser: 'user/createUser',
    }),
    save() {
      this.saving = true
      this.createUser(this.user)
        .then((response) => {
          if (response.status === 200 || response.status === 201) {
            this.$notify.success({
              title: SUCCESS_MESSAGES.userAddSaveSuccessTitle(),
              message: SUCCESS_MESSAGES.userAddSaveSuccessMessage(this.user.email),
              type: 'success',
              position: 'bottom-right',
            })
            this.$router.push({
              name: 'administrators',
            })
          }
        })
        .finally(() => {
          this.saving = false
        })
    },
  },
}
</script>
